import {Dialog} from './dialog.js';

export class DialogOutdatedcordovalocanto extends Dialog {
	static PAGE_LOAD_COUNTER_KEY = 'outdatedcordovalocanto_pageload_counter';
	static TRIGGER_DIALOG_THRESHHOLD = 1;
	static SKIP_PAGE_LOAD_PROMO = ['cart', 'book_upgrade', 'checkout_address', 'checkout', 'premium_cancel', 'PAF_create_new'];
	init() {
		super.init();
	}
	
	load() {
		super.load();
		this.page_load_counter();
		this.track.view();
		if (this.can_show_promo_on_page_load()) {
			this.show();
		}
		return this;
	}
	
	get track() {
		return ['view', 'download', 'later'].reduce((accumulator, action) => {
			accumulator[action] = () => yalwa.basics.ga.event({
				category: 'outdatedcordovalocanto_dialog',
				action,
				label: yalwa.basics.yalwapp_version()
			});
			return accumulator;
		}, {});
	}
	
	visibility_change_handler() {
		switch (document.visibilityState) {
			case 'visible':
				this.show();
				break;
		}
	}
	
	add_events() {
		super.add_events();
		this.$dialog.find(`.js-${this.component.component_type}_download`).off('click.track').on('click.track', this.track.download.bind(this));
		this.$dialog.find(`.js-${this.component.component_type}_later`).off('click.track').on('click.track', this.track.later.bind(this)).off('click.navigate').on('click.navigate', this.open_in_chrome.bind(this));
		this.$dialog.find(`.js-${this.component.component_type}_open_in_safari`).off('click.track').on('click.track', this.track.later.bind(this)).off('click.navigate').on('click.navigate', this.open_in_safari.bind(this));
		document.addEventListener("visibilitychange", this.visibility_change_handler.bind(this));
	}
	
	/**
	 * Increment counter on every init
	 */
	page_load_counter() {
		let totalClicks = yalwa.basics.ss_get(DialogOutdatedcordovalocanto.PAGE_LOAD_COUNTER_KEY) || 0;
		yalwa.basics.ss_set(DialogOutdatedcordovalocanto.PAGE_LOAD_COUNTER_KEY, parseInt(totalClicks) + 1);
	}
	total_page_loads() {
		return parseInt(yalwa.basics.ss_get(DialogOutdatedcordovalocanto.PAGE_LOAD_COUNTER_KEY)) || 0;
	}
	can_show_promo_on_page_load() {
		return ( (DialogOutdatedcordovalocanto.SKIP_PAGE_LOAD_PROMO.indexOf(yalwa.basics.get_routing()) === -1) && (this.total_page_loads() % DialogOutdatedcordovalocanto.TRIGGER_DIALOG_THRESHHOLD) === 0);
	}
	open_in_chrome(e) {
		e.preventDefault();
		yalwa.mobile.cordova.openintent(jQuery(e.currentTarget).attr('href'));
	}
	
	open_in_safari(e) {
		e.preventDefault();
		let url = jQuery(e.currentTarget).attr('href');
		yalwa.basics.cordova_send({action: 'openpartner', params: {url: url}});;
	}
}
